import { LOCATION_CHANGE } from 'react-router-redux';
import createReducer from '../utils/createReducer';
import {
  PROMPT_MESSAGE,
  PROMPT_MESSAGE_RESET,
} from '../constants/actions';

const initialState = {
  header: null,
  message: null,
  icon: null,
  show: false,
  callback: null,
};

export default createReducer(initialState, {
  [PROMPT_MESSAGE]: (state, payload) => (
    Object.assign({}, state, {
      header: payload.header,
      message: payload.message,
      icon: payload.icon,
      samePage: payload.samePage,
      show: payload.show,
      callback: payload.callback,
    })
  ),
  [PROMPT_MESSAGE_RESET]: () => (
    Object.assign({}, initialState)
  ),
  [LOCATION_CHANGE]: () => (
    Object.assign({}, initialState)
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/prompt.js